import { render } from "./GridBilanturi.vue?vue&type=template&id=b19fead6&ts=true"
import script from "./GridBilanturi.vue?vue&type=script&lang=ts"
export * from "./GridBilanturi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__